import React from 'react';
import { Container, Typography, Box, List, ListItem } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';



const Cookies = () => {

    const { i18n } = useTranslation();
    const lang = i18n.language;
    return (
        <Container maxWidth="md" sx={{ py: 5 }}>
            <Typography variant="h4" gutterBottom>
                Sütik
            </Typography>

            <Typography paragraph>
                Ez a weboldal sütiket használ a felhasználói élmény javítása érdekében.
            </Typography>

            <Typography paragraph>
                A sütik olyan kisméretű szöveges fájlok, amelyeket a weboldalak helyeznek el
                a felhasználó számítógépén vagy mobil eszközén. A sütik segítségével a
                weboldalak megjegyzik a felhasználó beállításait, preferenciáit, valamint
                bizonyos információkat gyűjtenek a felhasználói tevékenységekről.
            </Typography>

            <Typography paragraph>
                Weboldalunkon elsődlegesen következő típusú sütiket használunk:
            </Typography>

            <Box sx={{ pl: 2 }}>
                <List sx={{ listStyleType: 'disc', pl: 2 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                        <Typography>
                            <strong>Szükséges sütik:</strong> Ezek a sütik elengedhetetlenek a
                            weboldal megfelelő működéséhez. Nem tárolnak személyes adatokat.
                        </Typography>
                    </ListItem>

                    <ListItem sx={{ display: 'list-item' }}>
                        <Typography>
                            <strong>Teljesítmény sütik:</strong> Ezek a sütik információkat
                            gyűjtenek a weboldal látogatóinak viselkedéséről, például mely
                            oldalakat látogatják leggyakrabban. Ezek az adatok névtelenek és
                            segítenek nekünk a weboldalunk optimalizálásában.
                        </Typography>
                    </ListItem>

                    <ListItem sx={{ display: 'list-item' }}>
                        <Typography>
                            <strong>Statisztikai sütik:</strong> Ezek a sütik segítenek nekünk
                            megérteni, hogyan használják a látogatók a weboldalt, és
                            információkat szolgáltatnak a látogatók demográfiai adatairól. Ezek
                            az adatok névtelenek és segítenek nekünk a weboldalunk fejlesztésében.
                        </Typography>
                    </ListItem>
                </List>
            </Box>

            <Typography paragraph sx={{ mt: 2 }}>
                Ha nem szeretné, hogy a weboldalunk sütiket helyezzen el a számítógépén,
                akkor a böngésző beállításaiban letilthatja a sütik fogadását. Azonban ez
                esetben előfordulhat, hogy nem tudja teljes mértékben kihasználni a
                weboldalunk funkcióit.
            </Typography>

            <Typography paragraph>
                További információért olvassa el{' '}
                <RouterLink to={`/${lang}/privacy-policy`}>
                    Adatvédelmi szabályzatunkat
                </RouterLink>.
            </Typography>
        </Container>
    );
};

export default Cookies;
